import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {METRIC_ALL} from '/enum/metric.enum';
import {competencyById} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {metricLastRefreshedByKey} from '/redux/selector/metric.meta.selector';
import {withProps} from '/util/selector.util';

import Timestamp from './Timestamp';

const withCurrentUserCoachId = withProps({coachId: userId});
const withAllMetricKey = withProps({metaKey: METRIC_ALL});

export const TimestampConnect = connect(
  createStructuredSelector({
    competency: withCurrentUserCoachId(competencyById),
    refreshTime: withAllMetricKey(metricLastRefreshedByKey),
  }),
  {},
)(Timestamp);
